import { Injectable } from '@angular/core';
import { ApplicationConfig } from '@frontend-site/shared/data';
import { Repository } from '@frontend-site/shared/utils';
import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';
import { RdxContext } from './rdx-context';
import { RdxContextState } from './rdx-context-state';
import { RdxContextType } from './rdx-context-type.enum';
import { ProjectStore } from '../project';

function createInitialState(): RdxContextState {
    return {
        context: null
    };
}

@Injectable({
    providedIn: 'root'
})
export class RdxContextStore extends Repository<RdxContextState> {
    rdxContext$: Observable<RdxContext | null> = this.store.pipe(select((state) => state.context));

    get rdxContext(): RdxContext | null {
        return this.getValue().context;
    }

    get isCompanyContext() {
        return this.rdxContext?.contextType !== RdxContextType.RDX_TC_PROJECT && this.rdxContext?.contextType !== RdxContextType.TC_PROJECT;
    }

    get rdxContextAsParams() {
        const context = this.getValue().context;
        if (context) {
            let params = {
                contextId: context.contextId,
                contextType: context.contextType
            };
            if (params.contextType == RdxContextType.SYSTEM) {
                return { ...params, companyId: context.companyId };
            }
            if (this.isCompanyContext) {
                return { ...params, companyId: context.contextId };
            }
            return {
                ...params,
                projectId: context.contextId,
                systemId: this.projectStore.projectDetails?.systemId,
                companyId: this.projectStore.projectDetails?.companyId
            };
        }
        return {};
    }

    constructor(private projectStore: ProjectStore) {
        super(createStore({ name: 'RdxContextStore' }, withProps<RdxContextState>(createInitialState())));
    }

    public updateContext(contextId: number, contextType: RdxContextType, appConfig: ApplicationConfig): void {
        let updatedContextType = RdxContextStore.getContextTypeByAppConfig(contextType, appConfig);
        let rdxContext = new RdxContext(updatedContextType, contextId);
        if (contextType == RdxContextType.SYSTEM) {
            rdxContext.companyId = appConfig.companyId;
        }
        this.update({ context: rdxContext });
    }

    private static getContextTypeByAppConfig(contextType: RdxContextType, appConfig: ApplicationConfig): RdxContextType {
        if (contextType == RdxContextType.PROJECT) {
            if (appConfig.rdxEnabled) {
                return RdxContextType.RDX_TC_PROJECT;
            }
            return RdxContextType.TC_PROJECT;
        }
        return contextType;
    }

    isRdxContext() {
        if (this.rdxContext && this.rdxContext.contextType) {
            return (
                this.rdxContext.contextType === RdxContextType.PORTFOLIO ||
                this.rdxContext.contextType === RdxContextType.PROJECT ||
                this.rdxContext.contextType === RdxContextType.RELEASE ||
                this.rdxContext.contextType === RdxContextType.RDX_PCQ
            );
        }
        return false;
    }
}
